"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentMoney = void 0;
var rich_content_money_1 = require("./rich-content-money");
Object.defineProperty(exports, "RichContentMoney", { enumerable: true, get: function () { return rich_content_money_1.RichContentMoney; } });
